module.exports = __webpack_public_path__ + "static/media/o5.cc588c0a.png";